useScriptTag('/sdk/uni.webview.1.5.6.js', () => {
  window.uniWebview ??= {}
})
if (import.meta.client) {
  // sb uni 没有onload事件, 手动触发一个
  document.addEventListener('plusready', () => {
    callHandler({
      action: 'onLoad',
    })
  })
}
export function nativeGoLogin() {
  go2NativePage('/pages/login/index')
}

export function nativeGoBack() {
  uni.navigateBack()
}

export function go2NativePage(url, redirectTo = false) {
  redirectTo ? uni.redirectTo({ url }) : uni.navigateTo({ url })
}

export function callHandler(msg, cb = () => {}) {
  uni.postMessage({ data: msg })
  const { action } = msg
  return new Promise((resolve) => {
    window.uniWebview[action] = (data) => {
      cb(data)
      resolve(data)
      delete window.uniWebview[action]
    }
  })
}

export async function getTheme() {
  const data = await callHandler({ action: 'getTheme' })
  if (data?.theme) {
    return data.theme
  }
  return 'light'
}

export default {
  nativeGoLogin,
  nativeGoBack,
  go2NativePage,
  callHandler,
  getTheme,
}
